export default __webpack_public_path__ + "static/media/m_ceoLadingStore01.ef4ef225.png";